module.exports = __webpack_public_path__ + "static/media/sales-market.7b063966.svg";